const breadCrumb = "Lotação de Servidores - Manutenção de Informações Servidor";

const routes = [
  {
    path: "/registrar-substituicao-do-servidor",
    name: "registrar-substituicao-do-servidor",
    meta: {
      allowedPermissions: ["substituicao_servidor_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoDeInformacoesDoServidor/MovimentacaoDoServidor/RegistrarSubstituicaoDoServidor/RegistrarSubstituicaoDoServidorHome.vue"
      ),
  },
  {
    path: "/registrar-substituicao-do-servidor/novo/:lotacaoId/:servidorId",
    name: "registrar-substituicao-do-servidor-novo",
    meta: {
      allowedPermissions: ["substituicao_servidor_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoDeInformacoesDoServidor/MovimentacaoDoServidor/RegistrarSubstituicaoDoServidor/RegistrarSubstituicaoDoServidorCad.vue"
      ),
  },
];

export default routes;
